// extracted by mini-css-extract-plugin
export var active = "_ms-2";
export var recordingDot = "_ms-1";
export var recordingIndicator = "_ms-0";